import {
  SIGNUP_SUCCESS,
  SIGNUP_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  ACTIVATION_SUCCESS,
  ACTIVATION_FAIL,
  SET_AUTH_LOADING,
  REMOVE_AUTH_LOADING,
  USER_LOADED_SUCCESS,
  USER_LOADED_FAIL,
  AUTHENTICATED_SUCCESS,
  AUTHENTICATED_FAIL,
  REFRESH_SUCCESS,
  REFRESH_FAIL,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_CONFIRM_SUCCESS,
  RESET_PASSWORD_CONFIRM_FAIL,
  LOGOUT,
} from "./types";
import http from "../../utils/http";
import { toast } from "react-toastify";
import { store } from "../../store";
import { removeLoader, setLoader } from "../actions/loader";

export const load_user = ({ silent = false } = {}) => {
  return async (dispatch) => {
    try {
      const res = await http.get(`/auth/users/me/`);
      if (res.status === 200) {
        dispatch({
          type: USER_LOADED_SUCCESS,
          payload: res.data,
        });
        return true;
      }
    } catch (err) {
      if (!silent) {
        dispatch({
          type: USER_LOADED_FAIL,
        });
      }
      return false;
    }

    if (!silent) {
      dispatch({
        type: USER_LOADED_FAIL,
      });
    }

    return false;
  };
};

export const initialize_auth = () => {
  return async (dispatch) => {
    try {
      const userLoaded = await dispatch(load_user({ silent: true }));
      if (userLoaded) {
        dispatch({ type: AUTHENTICATED_SUCCESS });
        return true;
      }

      const refreshed = await dispatch(refresh());
      if (!refreshed) {
        dispatch({ type: AUTHENTICATED_FAIL });
        return false;
      }

      const reloadedUser = await dispatch(load_user({ silent: true }));
      if (reloadedUser) {
        dispatch({ type: AUTHENTICATED_SUCCESS });
        return true;
      }

      dispatch({ type: AUTHENTICATED_FAIL });
      return false;
    } catch (err) {
      dispatch({ type: AUTHENTICATED_FAIL });
      return false;
    }
  };
};

export const check_authenticated = () => {
  return async (dispatch) => {
    const userLoaded = await dispatch(load_user({ silent: true }));
    dispatch({
      type: userLoaded ? AUTHENTICATED_SUCCESS : AUTHENTICATED_FAIL,
    });
    return userLoaded;
  };
};

export const signup = (
  email,
  password,
  re_password,
  first_name,
  last_name,
  document_id,
  phone,
  responsible,
  prescriptor,
  bank_account,
  coeficient_d,
  parent,
  price_list_preffix,
  erp_user_id,
  delegacion,
  is_internal_agent,
  is_call_agent,
) => {
  return async (dispatch) => {
    dispatch({ type: SET_AUTH_LOADING });

    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      email,
      password,
      re_password,
      first_name,
      last_name,
      document_id,
      phone,
      responsible,
      prescriptor,
      bank_account,
      coeficient_d,
      parent,
      price_list_preffix,
      erp_user_id,
      delegacion,
      is_internal_agent,
      is_call_agent,
    });

    try {
      store.dispatch(setLoader("Creando Usuario, enviaremos un correo para activar tu cuenta"));
      const res = await http.post(`/auth/users/`, body, config);
      dispatch({ type: SIGNUP_SUCCESS, payload: res.data });
      return { ok: true, data: res.data };
    } catch (err) {
      const data = err.response?.data;
      let mensaje = "Error en el registro.";
      if (data) {
        if (typeof data === "string") {
          mensaje = data;
        } else {
          mensaje = Object.values(data).flat().join(" ");
        }
      }
      toast.error(mensaje, { position: toast.POSITION.TOP_CENTER });

      dispatch({ type: SIGNUP_FAIL });
      dispatch({ type: REMOVE_AUTH_LOADING });
      return { ok: false, message: mensaje, fields: data };
    } finally {
      store.dispatch(removeLoader());
    }
  };
};
export const patch_user = (data) => {
  return async (dispatch) => {
    try {
      store.dispatch(setLoader("Actualizando datos del usuario"));
      const res = await http.patch(`/auth/users/me/`, data);
      if (res.status === 200) {
        dispatch({
          type: USER_LOADED_SUCCESS,
          payload: res.data,
        });
      }
    } catch (err) {
      dispatch({
        type: USER_LOADED_FAIL,
      });
      toast.error("Error al actualizar los datos.", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      store.dispatch(removeLoader());
    }
  };
};

export const login = (email, password) => {
  return async (dispatch) => {
    dispatch({
      type: SET_AUTH_LOADING,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      email,
      password,
    });

    try {
      const res = await http.post(`/auth/jwt/create/`, body, config);
      if (res.status === 200) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: res.data,
        });

        const userLoaded = await dispatch(load_user({ silent: true }));
        if (!userLoaded) {
          throw new Error("No se pudo cargar la sesión");
        }

        toast.success("Inicio de sesión con éxito.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        dispatch({
          type: LOGIN_FAIL,
        });
        dispatch({
          type: REMOVE_AUTH_LOADING,
        });
        toast.error("Error al iniciar sesion.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (err) {
      dispatch({
        type: LOGIN_FAIL,
      });
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
      toast.error("Error al iniciar sesion. Intenta mas tarde.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
};

export const activate = (uid, token) => {
  return async (dispatch) => {
    dispatch({
      type: SET_AUTH_LOADING,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      uid,
      token,
    });
    try {
      store.dispatch(setLoader("Activando Usuario"));
      const res = await http.post(`/auth/users/activation/`, body, config);
      if (res.status === 204) {
        dispatch({
          type: ACTIVATION_SUCCESS,
        });
        toast.success("Cuenta activada correctamente.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        dispatch({
          type: ACTIVATION_FAIL,
        });
        toast.error("Error al activar cuenta.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
    } catch (err) {
      dispatch({
        type: ACTIVATION_FAIL,
      });
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
      toast.error("Error al conectar con el servidor, intenta mas tarde.", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      store.dispatch(removeLoader());
    }
  };
};

export const refresh = () => {
  return async (dispatch) => {
    try {
      const refreshToken = localStorage.getItem("refresh");
      if (!refreshToken) {
        dispatch({
          type: REFRESH_FAIL,
        });
        return false;
      }

      const res = await http.post(`/auth/jwt/refresh/`, {
        refresh: refreshToken,
      });
      if (res.status === 200) {
        dispatch({
          type: REFRESH_SUCCESS,
          payload: res.data,
        });
        return true;
      }
    } catch (err) {
      dispatch({
        type: REFRESH_FAIL,
      });
    }

    return false;
  };
};

export const reset_password = (email) => {
  return async (dispatch) => {
    dispatch({
      type: SET_AUTH_LOADING,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({ email });

    try {
      const res = await http.post(`/auth/users/reset_password/`, body, config);
      if (res.status === 204) {
        dispatch({
          type: RESET_PASSWORD_SUCCESS,
        });
        dispatch({
          type: REMOVE_AUTH_LOADING,
        });
        toast.success("Se ha enviado un email para cambiar la contraseña.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        dispatch({
          type: RESET_PASSWORD_FAIL,
        });
        dispatch({
          type: REMOVE_AUTH_LOADING,
        });
        toast.error("Error al enviar el mail de cambio de contraseña, intenta mas tarde.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (err) {
      dispatch({
        type: RESET_PASSWORD_FAIL,
      });
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
      toast.error("Error al enviar el mail de cambio de contraseña, intenta mas tarde.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
};

export const reset_password_confirm = (
  uid,
  token,
  new_password,
  re_new_password
) => {
  return async (dispatch) => {
    dispatch({
      type: SET_AUTH_LOADING,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      uid,
      token,
      new_password,
      re_new_password,
    });

    if (new_password !== re_new_password) {
      dispatch({
        type: RESET_PASSWORD_CONFIRM_FAIL,
      });
      dispatch({
        type: REMOVE_AUTH_LOADING,
      });
      toast.error("Las contraseñas no coinciden.", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      try {
        const res = await http.post(`/auth/users/reset_password_confirm/`, body, config);
        if (res.status === 204) {
          dispatch({
            type: RESET_PASSWORD_CONFIRM_SUCCESS,
          });
          dispatch({
            type: REMOVE_AUTH_LOADING,
          });
          toast.success("La contraseña a sido cambiada correctamente.", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        } else {
          dispatch({
            type: RESET_PASSWORD_CONFIRM_FAIL,
          });
          dispatch({
            type: REMOVE_AUTH_LOADING,
          });
          toast.error("Error al cambiar la contraseña.", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (err) {
        dispatch({
          type: RESET_PASSWORD_CONFIRM_FAIL,
        });
        dispatch({
          type: REMOVE_AUTH_LOADING,
        });
        toast.error("Error al cambiar la contraseña.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    try {
      const refresh = localStorage.getItem("refresh");
      if (refresh) {
        await http.post(`/auth/jwt/logout/`, { refresh });
      }
    } catch (err) {
      // Si el backend ya no reconoce la sesión, limpiamos igual el estado local.
    }

    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    dispatch({
      type: LOGOUT,
    });
    toast.success("Sesión cerrada correctamente.", {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  };
};
